import { anonApiFactory } from '../lib/anonUtils';
import { apiV2Factory } from '../lib/baseAxios';
import { IVFSResponse } from './fileSystemService';

interface ImportFileOptions {
  intent?: string;
}

interface ImportUrlResponseBody {
  status: 'processing';
}

const processImportFile = async (
  teamId: string,
  folderId: string,
  url: string,
  options: ImportFileOptions,
) => {
  const apiV2Client = apiV2Factory();
  return apiV2Client.post<IVFSResponse<ImportUrlResponseBody>>(
    `/file-ops/import/${teamId}/${folderId}`,
    { url, options },
  );
};

export const processImportFileAnonUser = async (
  teamId: string,
  folderId: string,
  url: string,
  options: ImportFileOptions,
) => {
  const apiV2Client = anonApiFactory();

  return apiV2Client.post<IVFSResponse<ImportUrlResponseBody>>(
    `/file-ops/anon/import/${teamId}/${folderId}`,
    { url, options },
  );
};

export default processImportFile;
